module.exports = __webpack_public_path__ + "static/media/terraform002.700bb598.png";